// src/eden/context/useEdenContext.js
// React hook to subscribe to EdenContextBridge updates.
// Use this in GlobalVoiceController and any Eden UI panel.

import { useEffect, useState } from "react";
import edenContextBridge from "./EdenContextBridge";

export default function useEdenContext() {
  const [context, setContext] = useState(() => edenContextBridge.getContext());

  useEffect(() => {
    const unsubscribe = edenContextBridge.subscribe((ctx) => {
      setContext(ctx);
    });
    return unsubscribe;
  }, []);

  return context;
}
